import { useTimelineStore } from '@/stores/api/timeline.js';
import { render } from '@/threejs/core';
import { animationManager } from '@/threejs/managers/animationManager';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTimelinePlayerStore = defineStore('timelinePlayer', () => {
  const timelineStore = useTimelineStore();

  const currentTime = ref(0);
  const isPlaying = ref(false);

  const play = () => {
    isPlaying.value = true;
    animationManager.play();
  };

  const pause = () => {
    isPlaying.value = false;
    animationManager.pause();
  };

  const togglePlay = () => {
    if (isPlaying.value) {
      pause();
    } else {
      play();
    }
  };

  const stop = () => {
    isPlaying.value = false;
    currentTime.value = 0;
    animationManager.stop();
  };

  const restart = () => {
    currentTime.value = 0;
    isPlaying.value = true;
    animationManager.setTime(0);
    animationManager.play();
  };

  const setCurrentTime = (time) => {
    currentTime.value = time;
    animationManager.setTime(time);
    render();
  };

  // Update current time from animation manager (called in animation loop)
  const updateFromAnimationManager = () => {
    if (isPlaying.value) {
      currentTime.value = animationManager.getCurrentTime();
    }
  };

  const hasKeyframe = (objectId, key) => {
    const layer = timelineStore.currentTimeline.find((layer) => layer.objectId === objectId && layer.key === key);
    return layer ? layer.keyframes.length > 0 : false;
  };

  return {
    currentTime,
    isPlaying,
    togglePlay,
    play,
    pause,
    stop,
    restart,
    setCurrentTime,
    updateFromAnimationManager,
    hasKeyframe,
  };
});
